(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.mv-header').forEach(header => {
      if (header.dataset.mvReady) return;
      header.dataset.mvReady = 'true';
      const menus = [...header.querySelectorAll('.mv-dropdown')];
      const positionMenus = () => header.style.setProperty('--mv-menu-top', header.getBoundingClientRect().bottom + 'px');
      new ResizeObserver(positionMenus).observe(header);
      positionMenus();
      menus.forEach(menu => menu.addEventListener('toggle', () => {
        if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
      }));
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) menus.forEach(menu => { menu.open = false; });
      });
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = menus.find(menu => menu.open);
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      });
      menus.forEach(menu => menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; })));
    });
    root.querySelectorAll('[data-mv-home]').forEach(home => {
      if (home.dataset.mvReady) return;
      home.dataset.mvReady = 'true';
      const track = home.querySelector('[data-mv-reviews]');
      if (!track) return;
      const progress = home.querySelector('[data-mv-review-progress]');
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        progress.style.width = maximum > 0 ? (20 + 80 * track.scrollLeft / maximum) + '%' : '100%';
      };
      const move = direction => {
        const card = track.querySelector('.mv-review');
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + 22), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      home.querySelector('[data-mv-review-prev]').addEventListener('click', () => move(-1));
      home.querySelector('[data-mv-review-next]').addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();